"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.defekt = void 0;
const humanize_string_1 = __importDefault(require("humanize-string"));
const defekt = function (errorDefinitions) {
    var _a;
    const errors = {};
    /* eslint-disable guard-for-in */
    for (const errorName in errorDefinitions) {
        const errorDefinition = errorDefinitions[errorName];
        const { code = `E${errorName.toUpperCase()}` } = errorDefinition;
        errors[errorName] = (_a = class extends Error {
                /* eslint-disable default-param-last */
                constructor(message = `${humanize_string_1.default(errorName)}.`, { cause, data } = {}) {
                    /* eslint-enable default-param-last */
                    super();
                    this.name = errorName;
                    this.code = code;
                    this.message = message;
                    this.cause = cause;
                    this.data = data;
                }
            },
            _a.code = code,
            _a);
    }
    /* eslint-enable guard-for-in */
    return errors;
};
exports.defekt = defekt;
